import React from "react";

const zoomOutIcon = (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect x="3" y="11" width="18" height="2" rx="1" fill="#D1D1D9" />
	</svg>
);

export default zoomOutIcon;
